import { getBridge } from './consumer';
var updateHeight = function (element) {
    getBridge().updateHeight(element.offsetHeight);
};
export var registerHeightReporter = function (container) {
    if (container === void 0) { container = document.documentElement; }
    var resizeObserver = new ResizeObserver(function () { return updateHeight(container); });
    resizeObserver.observe(container);
    return function () { return resizeObserver.disconnect(); };
};
//# sourceMappingURL=heightReporter.js.map